const MDY = new Set(['en-US']);
const YMD = new Set(['hu', 'hu-HU', 'zh-HK', 'zh-CN', 'ja', 'ja-JP']);

export { MDY, YMD };
//# sourceMappingURL=getFormatForLocale.mjs.map
